import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import SVGA from 'svgaplayerweb'
import $ from 'jquery';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import bindModel from '../../../common/bindModel';
import Swal from 'sweetalert2';

export default class ModalCreate extends Component {

    constructor(props) {
        super(props);

        this.state = {
            model: null,
            loading: false,
            isEventPost: false,
        }

        this.createOrUpdate = this.createOrUpdate.bind(this);
        this.uploadThumbnail = this.uploadThumbnail.bind(this);
        this.uploadVideo = this.uploadVideo.bind(this);
        this.generateThumbnailFromVideoFile = this.generateThumbnailFromVideoFile.bind(this);
        this.handleEventPostChange = this.handleEventPostChange.bind(this);
        this.guid = this.guid.bind(this);
    }


    createOrUpdate() {
        const { model, isEventPost } = this.state;
        if (
            !model ||
            !model.postType ||
            !model.message ||
            !model.fanPage
        ) {
            toast.warning("Nhập đầy đủ thông tin");
            return
        }

        if (new Date(model.endTime) <= new Date(model.startTime)) {
            toast.warning("Thời gian kết thúc phải lớn hơn thời gian bắt đầu " + model.startTime + " " + model.endTime);
            return;
        }

        const deepLinkJoinButton = model.deepLinkJoinButton && model.deepLinkJoinButton.trim();
        if (isEventPost && !deepLinkJoinButton) {
            toast.warning("Nhập deeplink sự kiện");
            return;
        }

        let arr = [];
        if (model.videoUrl) {
            arr.push(model.videoUrl);
        }
        model.subVideos = arr
        if (model.postType == 'VIDEO' && (!model.subVideos || model.subVideos.length > 1)) {
            toast.warning("Post Video chỉ 1 video");
            return
        }
        if (model.postType == 'PLAYLIST' && (!model.subVideos || model.subVideos.lenght <= 1)) {
            toast.warning("Post Playlist phải từ 2 link video");
            return
        }
        const modelToSend = {
            ...model,
            subVideos: arr,
            deepLinkJoinButton: isEventPost ? deepLinkJoinButton : null
        };
        delete modelToSend.videoUrl;

        this.setState({
            loading: true
        });

        axios.post(global.config.apiDomain + "/rest/userPost/createOrUpdate", JSON.stringify(modelToSend), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => {
                this.setState({
                    loading: false
                });
                if (res.data && res.data.status == "OK") {
                    window.$("#modalCreate").modal("hide");
                    toast.success(res.data.message);
                    this.props.resetList(model.facebookId);
                } else {
                    toast.success(res.data.message)
                }
            })

    }

    componentWillReceiveProps(props) {
        const { model } = props;
        if (model == null) return;
        
        // Khởi tạo giá trị mặc định cho startTime và endTime nếu chưa có
        const defaultModel = {
            ...model,
            startTime: model.startTime || new Date(),
            endTime: model.endTime || (() => {
                const tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                return tomorrow;
            })(),
            videoUrl: (model.subVideos && model.subVideos[0]) || '',
            isPostFB: model.isPostFB !== undefined ? model.isPostFB : true, // Mặc định là true
            deepLinkJoinButton: model.deepLinkJoinButton || ''
        };

        this.setState({
            model: defaultModel,
            isEventPost: Boolean(model.deepLinkJoinButton)
        });
    }

    handleEventPostChange(event) {
        const isChecked = event.target.checked;
        if (!isChecked) {
            this.setState(prevState => ({
                isEventPost: false,
                model: {
                    ...prevState.model,
                    deepLinkJoinButton: ''
                }
            }));
            return;
        }

        Swal.fire({
            title: 'Xác nhận bài đăng sự kiện?',
            text: 'Bài đăng sẽ hiển thị nút Tham gia và dẫn người dùng đến màn hình chi tiết sự kiện.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Xác nhận',
            cancelButtonText: 'Hủy'
        }).then(result => {
            this.setState({
                isEventPost: result.isConfirmed
            });
        });
    }

    guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    uploadThumbnail(event) {
        var target = event.target;

        //05Dec24 Check if the file size exceeds 1MB
        if (event.target.files[0]?.size > 1048576) { // 1MB in bytes
            toast.error("Hình ảnh không được vượt quá dung lượng 1Mb.");
            return;
        }

        if (target.files[0]?.size > 10495760) {
            toast.error("Kích thước file phải dưới 10mb.");
            return;
        }
        const { model } = this.state;

        this.setState({
            loading: true
        });

        var bucketName = "ikara-data/images/userPost";
        var extension = target.files[0].name.split('.').pop().toLowerCase();
        var keyName = this.guid() + "." + extension;
        var contentType = "image/jpeg";
        if (extension == "png") contentType = "image/png";
        if (extension == "jpg" || extension == "jpeg") contentType = "image/jpeg";
        if (extension == "gif") contentType = "image/gif";
        
        const AWS = window.AWS;
        var credentials = new AWS.Credentials("writeonlyuser", "awJBPnZwvVpGYmp5MDQsw3Ry7z5EsyAE");
        var ep = new AWS.Endpoint("https://data4.ikara.co:9000");
        var s3 = new AWS.S3({
            endpoint: ep,
            credentials: credentials,
            region: 'us-east-1',
            s3ForcePathStyle: true,
            httpOptions: {
                timeout: 0 
            }
        });

        var fileReader = new FileReader();

        fileReader.onload = function () {
            var data = fileReader.result;
            var params = {
                ACL: 'public-read',
                ContentType: contentType,
                Bucket: bucketName,
                Key: keyName,
                Body: data
            };
            var upload = new AWS.S3.ManagedUpload({
                params: params,
                service: s3
            });
            upload.send((err, data) => {
                if (err) {
                    console.error("Lỗi upload thumbnail:", err);
                    toast.error("Lỗi upload thumbnail");
                    this.setState({
                        loading: false
                    });
                } else {
                    console.log('Upload Thumbnail Success:', data);
                    this.setState({
                        loading: false,
                        model: {
                            ...this.state.model,
                            thumbnailImageUrl: 'https://data4.ikara.co/data/minio/' + bucketName + '/' + keyName
                        }
                    });
                }
            });
        }.bind(this);
        fileReader.readAsArrayBuffer(target.files[0]);
    }

    uploadVideo(event) {
        var target = event.target;
        var file = target.files[0];

        // Validate file type - chỉ cho phép video
        var allowedTypes = [
            'video/mp4'
        ];

        // Kiểm tra extension
        var extension = file.name.split('.').pop().toLowerCase();
        var allowedExtensions = ['mp4'];
        
        if (!allowedExtensions.includes(extension)) {
            toast.error("Chỉ được chọn file video (MP4)");
            target.value = ''; // Reset input
            return;
        }

        // Kiểm tra MIME type nếu có
        if (file.type && !allowedTypes.includes(file.type)) {
            toast.error("File không phải là video hợp lệ");
            target.value = ''; // Reset input
            return;
        }

        // Check if the file size exceeds 500MB
        if (file.size > 524288000) { // 500MB in bytes
            toast.error("Video không được vượt quá dung lượng 500MB.");
            target.value = ''; // Reset input
            return;
        }


        const { model } = this.state;

        this.setState({
            loading: true
        });

        var bucketName = "ikara-data/videos/userPost";
        var extension = target.files[0].name.split('.').pop().toLowerCase();
        var keyName = this.guid() + "." + extension;
        // Xác định content type dựa trên extension của video
        var contentType = "video/mp4";
        
        const AWS = window.AWS;
        var credentials = new AWS.Credentials("writeonlyuser", "awJBPnZwvVpGYmp5MDQsw3Ry7z5EsyAE");
        var ep = new AWS.Endpoint("https://data4.ikara.co:9000");
        var s3 = new AWS.S3({
            endpoint: ep,
            credentials: credentials,
            region: 'us-east-1',
            s3ForcePathStyle: true,
            httpOptions: {
                timeout: 0 
            }
        });
        var fileReader = new FileReader();

        fileReader.onload = function () {
            var fd = new FormData();
            fd.append('file', target.files[0]);
            fd.append('bucketName', bucketName);
            fd.append('objectKey', keyName);
            fd.append('contentType', contentType)
            var data = fileReader.result; // data <-- in this var you have the file data in Base64 format
            var params = {
                ACL: 'public-read',
                ContentType: contentType,
                Bucket: bucketName,
                Key: keyName,
                Body: data
            };
            var upload = new AWS.S3.ManagedUpload({
                params: params,
                service: s3
            });
            upload.send((err, data) => {
                if (err) {
                    console.error("Lỗi upload video:", err);
                    toast.error("Lỗi upload video");

                    this.setState({
                        loading: false
                    });
                } else {
                    console.log('Upload Success:', data);
                    const newVideoUrl = 'https://data4.ikara.co/data/minio/' + bucketName + '/' + keyName;
                    this.setState({
                        loading: false,
                        model: {
                            ...this.state.model,
                            videoUrl: newVideoUrl
                        }
                    }, () => {
                        // Force re-render video element
                        const videoElement = document.querySelector('#show-videoUrl video');
                        if (videoElement) {
                            videoElement.load();
                        }
                        // Tự động tạo thumbnail từ file video gốc
                        this.generateThumbnailFromVideoFile(target.files[0]);
                    });
                }
            });
        }.bind(this);
        fileReader.readAsArrayBuffer(target.files[0]);
    }

    generateThumbnailFromVideoFile(videoFile) {
        try {
            console.log('Tạo thumbnail từ file video:', videoFile);
            
            // Tạo video element tạm thời
            const video = document.createElement('video');
            video.muted = true;
            video.playsInline = true;
            video.crossOrigin = 'anonymous';
            
            // Tạo URL từ file
            const videoURL = URL.createObjectURL(videoFile);
            video.src = videoURL;
            
            video.onloadeddata = () => {
                try {
                    console.log('Video file đã load, kích thước:', video.videoWidth, 'x', video.videoHeight);
                    
                    // Tạo canvas
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    
                    // Set kích thước canvas
                    // const maxWidth = 800;
                    // const maxHeight = 600;
                    let width = video.videoWidth;
                    let height = video.videoHeight;
                    
                    // if (width > maxWidth || height > maxHeight) {
                    //     const ratio = Math.min(maxWidth / width, maxHeight / height);
                    //     width = Math.floor(width * ratio);
                    //     height = Math.floor(height * ratio);
                    // }
                    
                    canvas.width = width;
                    canvas.height = height;
                    
                    console.log('Canvas size:', width, 'x', height);
                    
                    // Đảm bảo video ở frame đầu tiên
                    video.currentTime = 0;
                    
                    video.onseeked = () => {
                        console.log('Video đã seek đến frame đầu tiên');
                        
                        // Vẽ frame lên canvas
                        ctx.drawImage(video, 0, 0, width, height);
                        
                        // Tạo blob
                        canvas.toBlob((blob) => {
                            if (blob) {
                                console.log('Tạo blob thành công, size:', blob.size);
                                const file = new File([blob], 'thumbnail.jpg', { type: 'image/jpeg' });
                                this.uploadThumbnailFromBlob(file);
                            } else {
                                console.error('Không thể tạo blob từ canvas');
                                toast.error('Không thể tạo thumbnail tự động');
                            }
                        }, 'image/jpeg', 0.8);
                        
                        // Cleanup
                        URL.revokeObjectURL(videoURL);
                    };
                    
                } catch (error) {
                    console.error('Lỗi khi tạo thumbnail từ file:', error);
                    toast.error('Không thể tạo thumbnail tự động: ' + error.message);
                    URL.revokeObjectURL(videoURL);
                }
            };
            
            video.onerror = () => {
                console.error('Lỗi khi tải video file');
                toast.error('Không thể tải video để tạo thumbnail');
                URL.revokeObjectURL(videoURL);
            };
            
            video.load();
            
        } catch (error) {
            console.error('Lỗi khi tạo thumbnail từ file:', error);
            toast.error('Không thể tạo thumbnail tự động: ' + error.message);
        }
    }

    uploadThumbnailFromBlob(file) {
        this.setState({
            loading: true
        });

        var bucketName = "ikara-data/images/userPost";
        var keyName = this.guid() + ".jpg";
        var contentType = "image/jpeg";
        
        const AWS = window.AWS;
        var credentials = new AWS.Credentials("writeonlyuser", "awJBPnZwvVpGYmp5MDQsw3Ry7z5EsyAE");
        var ep = new AWS.Endpoint("https://data4.ikara.co:9000");
        var s3 = new AWS.S3({
            endpoint: ep,
            credentials: credentials,
            region: 'us-east-1',
            s3ForcePathStyle: true,
            httpOptions: {
                timeout: 0 
            }
        });

        var fileReader = new FileReader();

        fileReader.onload = function () {
            var data = fileReader.result;
            var params = {
                ACL: 'public-read',
                ContentType: contentType,
                Bucket: bucketName,
                Key: keyName,
                Body: data
            };
            var upload = new AWS.S3.ManagedUpload({
                params: params,
                service: s3
            });
            upload.send((err, data) => {
                if (err) {
                    console.error("Lỗi upload thumbnail:", err);
                    toast.error("Lỗi upload thumbnail tự động");
                    this.setState({
                        loading: false
                    });
                } else {
                    console.log('Upload Thumbnail Success:', data);
                    this.setState({
                        loading: false,
                        model: {
                            ...this.state.model,
                            thumbnailImageUrl: 'https://data4.ikara.co/data/minio/' + bucketName + '/' + keyName
                        }
                    });
                    toast.success('Đã tạo thumbnail tự động từ video');
                }
            });
        }.bind(this);
        fileReader.readAsArrayBuffer(file);
    }

    addVideo() {
        $("#subVideos").append(`
            <div class="row">
                <div class='col-10'>
                    <input
                        class="form-control mb-2 inputChoice"
                        type="text"
                        name="order"
                        placeholder="Nhập Link video"
                    />
                </div>
                <div class='col-2'>
                    <button class='btn btn-danger btnDelete' 
                        onclick="this.parentElement.parentElement.innerHTML = ''"}>Xóa
                    </button>
                </div>
            </div>
        `)
    }

    render() {
        const bind = bindModel(this);
        const { model, isEventPost } = this.state;
        return (
            <div>
                <div className="modal fade" id="modalCreate" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalCenterTitle">{model && model.recordingId ? "Cập nhật bài đăng" : "Thêm mới bài đăng"}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div id="id" className="row mb-2">
                                    <div className="col-3">
                                        <label>ID</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            className="form-control mb-2"
                                            type="text"
                                            name="id"
                                            readOnly={true}
                                            {...bind('model.recordingId')}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3">
                                        <label>Thể loại</label>
                                    </div>
                                    <div className="col-9">
                                        <select
                                            className="form-control"
                                            type="text"
                                            {...bind('model.postType')}
                                        >
                                            <option value=''>CHỌN</option>
                                            <option value='STATUS'>Status</option>
                                            <option value='IMAGE'>Ảnh</option>
                                            <option value='VIDEO'>Video</option>
                                            <option value='PLAYLIST'>Playlist</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3">
                                        <label>Fan Page</label>
                                    </div>
                                    <div className="col-9">
                                        <select
                                            className="form-control"
                                            type="text"
                                            {...bind('model.fanPage')}
                                        >
                                            <option value=''>Lựa chọn FanPage ...</option>
                                            <option value='Yokara'>Yokara</option>
                                            <option value='Ikara'>Ikara</option>
                                            <option value='other'>Khác</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3">
                                        <label>Đồng bộ Facebook</label>
                                    </div>
                                    <div className="col-9">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="isPostFB"
                                                disabled={model && model.recordingId ? true : false}
                                                {...bind('model.isPostFB')}
                                            />
                                            <label className="form-check-label" htmlFor="isPostFB">
                                                {model && model.recordingId ? 
                                                    "Không thể thay đổi khi cập nhật" : 
                                                    "Đồng bộ bài đăng lên Facebook"
                                                }
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-3">
                                        <label>Bài đăng sự kiện</label>
                                    </div>
                                    <div className="col-9">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="isEventPost"
                                                checked={isEventPost}
                                                onChange={this.handleEventPostChange}
                                            />
                                            <label className="form-check-label" htmlFor="isEventPost">
                                                Hiển thị nút Tham gia trên bài đăng
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                {isEventPost ? (
                                    <div className="row mb-2">
                                        <div className="col-3">
                                            <label>Deeplink sự kiện</label>
                                        </div>
                                        <div className="col-9">
                                            <textarea
                                                rows="3"
                                                className="form-control mb-2"
                                                placeholder="Nhập deeplink dẫn đến chi tiết sự kiện"
                                                {...bind('model.deepLinkJoinButton')}
                                            />
                                        </div>
                                    </div>
                                ) : ''}
                                {model && model.postType && (model.postType != 'STATUS') ? <>
                                    <div id="thumbnailImageUrl" className="row mb-2">
                                        <div className="col-3">
                                            <label>Ảnh thumbnail</label>
                                        </div>
                                        <div className="col-9">
                                            <input
                                                className="custom-file-input"
                                                type="file"
                                                placeholder="Chọn hình mô tả"
                                                onChange={this.uploadThumbnail} />
                                            <label className="custom-file-label ml-3 mr-3" htmlFor="inputGroupFile03">Choose file</label>
                                        </div>
                                    </div>
                                    {model && model.thumbnailImageUrl ?
                                        <div id="reviewThumbnailUrl" className="row mb-2">
                                            <div className="col-3">
                                            </div>
                                            <div id="show-thumbnailUrl" className="col-9" style={{ maxHeight: "200px", overflow: "hidden"  }}>
                                                <img 
                                                    src={model.thumbnailImageUrl} 
                                                    style={{ 
                                                            maxWidth: "100%", 
                                                            maxHeight: "200px", 
                                                            objectFit: "contain",
                                                            display: "block"
                                                        }}  
                                                />
                                            </div>
                                        </div> : ''}
                                </> : ''}


                                <div id="name" className="row mb-2">
                                    <div className="col-3">
                                        <label>Mô tả</label>
                                    </div>
                                    <div className="col-9">
                                        <textarea rows="4"
                                            className="form-control mb-2"
                                            placeholder="Nhập mô tả"
                                            {...bind('model.message')} />
                                    </div>
                                </div>

                                {model && (model.postType == 'VIDEO' || model.postType == 'PLAYLIST') ?
                                    <>
                                        <div className="row mb-2">
                                            <div className="col-3">
                                                <label>Link Video</label>
                                            </div>
                                            <div className="col-9">
                                                <input
                                                    id='inputGroupFile04'
                                                    className="custom-file-input"
                                                    type="file"
                                                    accept="video/mp4"
                                                    placeholder="Chọn video"
                                                    onChange={this.uploadVideo} />
                                                <label className="custom-file-label ml-3 mr-3" htmlFor="inputGroupFile04">Choose file</label>
                                            </div>
                                        </div>
                                        {model && model.videoUrl ?
                                        <div id="reviewVideoUrl" className="row">
                                            <div className="col-3">
                                            </div>
                                            <div id="show-videoUrl" className="col-9" style={{ maxHeight: "300px" }}>
                                                <video 
                                                    key={model.videoUrl} // Force re-render khi URL thay đổi
                                                    controls 
                                                    width="300px" 
                                                    height="200px"
                                                    style={{ maxWidth: "100%", maxHeight: "300px" }}
                                                >
                                                    <source src={model.videoUrl} type="video/mp4" />
                                                    Trình duyệt của bạn không hỗ trợ thẻ video.
                                                </video>
                                            </div>
                                        </div> : ''}
                                    </>
                                    : ''}

                                <div className="row mb-2">
                                    <div className="col-3">
                                        <label>Post Link</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            className="form-control mb-2"
                                            type="text"
                                            placeholder="Nhập deepLink bài post"
                                            {...bind('model.postLink')} />
                                    </div>
                                </div>

                                <div id="startDate" className="row mb-2">
                                    <div className="col-3">
                                        <label>Ngày bắt đầu</label>
                                    </div>
                                    <div className="col-9">
                                    <DateTimePickerComponent
                                        {...bind('model.startTime')}
                                        value={model && model.startTime ? new Date(model.startTime) : new Date()}
                                        format="dd/MM/yyyy HH:00"
                                        step={60}
                                    >
                                    </DateTimePickerComponent>
                                    </div>
                                </div>
                                <div id="endDate" className="row mb-2">
                                    <div className="col-3">
                                        <label>Ngày kết thúc</label>
                                    </div>
                                    <div className="col-9">
                                    <DateTimePickerComponent
                                        {...bind('model.endTime')}
                                        value={model && model.endTime ? new Date(model.endTime) : (() => {
                                            const tomorrow = new Date();
                                            tomorrow.setDate(tomorrow.getDate() + 1);
                                            return tomorrow;
                                        })()}
                                        format="dd/MM/yyyy HH:00"
                                        step={60}
                                    >
                                    </DateTimePickerComponent>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-red" data-dismiss="modal">Hủy</button>
                                {this.state.loading ?
                                    (
                                        <button style={{ width: "120px" }} className="btn btn-red" type="button" disabled>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            Xác nhận...
                                        </button>
                                    ) :
                                    (
                                        <button style={{ width: "120px" }} type="button" className="btn btn-red"
                                            onClick={this.createOrUpdate}
                                        >Xác nhận</button>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
